import api from './api';

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.utiliti.ng";

const mediaService = {
    // Get all media personnel with filters and pagination
    getAllMediaPersonnel: async (params) => {
        try {
            const queryString = new URLSearchParams(params).toString();
            const response = await fetch(`${API_BASE_URL}/api/media?${queryString}`, {
                method: 'GET',
                headers: api.getAuthHeaders(),
            });

            const data = await response.json();
            if (!response.ok) {
                throw data;
            }
            return data;
        } catch (error) {
            throw error.message || 'Error fetching media personnel';
        }
    },

    // Get media personnel by ID
    getMediaPersonnelById: async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/media/${id}`, {
                method: 'GET',
                headers: api.getAuthHeaders(),
            });

            const data = await response.json();
            if (!response.ok) {
                throw data;
            }
            return data;
        } catch (error) {
            throw error.message || 'Error fetching media personnel details';
        }
    },

    // Verify media personnel
    verifyMediaPersonnel: async (id) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/media/${id}/verify`, {
                method: 'PUT',
                headers: api.getAuthHeaders(),
            });

            const data = await response.json();
            if (!response.ok) {
                throw data;
            }
            return data;
        } catch (error) {
            throw error.message || 'Error verifying media personnel';
        }
    },

    // Reject media personnel
    rejectMediaPersonnel: async (id, reason) => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/media/${id}/reject`, {
                method: 'PUT',
                headers: {
                    ...api.getAuthHeaders(),
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ reason })
            });

            const data = await response.json();
            if (!response.ok) {
                throw data;
            }
            return data;
        } catch (error) {
            throw error.message || 'Error rejecting media personnel';
        }
    }
};

export default mediaService;
